<template>
  <ValidationObserver ref="observer" tag="form">
    <b-modal
      id="thay-doi-mat-khau"
      ref="thay-doi-mat-khau"
      centered
      size="md"
      title="Thay đổi mật khẩu"
    >
      <div class="row">
        <div class="col-md-12">
          <b-form>
            <div id="mat-khau-nguoi-dung">
              <b-form-group
                  class="required"
                  label="Mật khẩu cũ"
              >
                <ValidationProvider name="mật khẩu cũ" rules="required">
                  <div slot-scope="{ errors }">
                    <b-form-input
                        v-model="internalForm.password"
                        type="password"
                        placeholder=""
                        rows="2"
                        max-rows="100"
                        no-resize
                        :class="{ 'is-danger': errors.length > 0 }"
                    />
                    <p class="font-size-14 mt-1" :class="{ error: errors.length > 0 }">{{ errors[0] }}</p>
                  </div>
                </ValidationProvider>
              </b-form-group>
              <b-form-group
                  class="required"
                  label="Mật khẩu mới"
              >
                <ValidationProvider name="mật khẩu mới" vid="password" rules="required" >
                  <div slot-scope="{ errors }">
                    <b-form-input
                        v-model="internalForm.newPassword"
                        type="password"
                        placeholder=""
                        rows="2"
                        max-rows="100"
                        no-resize
                        :class="{ 'is-danger': errors.length > 0 }"
                    />
                    <p class="font-size-14 mt-1" :class="{ error: errors.length > 0 }">{{ errors[0] }}</p>
                  </div>
                </ValidationProvider>
              </b-form-group>
              <b-form-group
                  class="required"
                  label="Xác nhận lại mật khẩu mới"
              >
                <ValidationProvider name="xác nhận mật khẩu" rules="required|confirmed:password">
                  <div slot-scope="{ errors }">
                    <b-form-input
                        v-model="internalForm.confirmPassword"
                        type="password"
                        placeholder=""
                        rows="2"
                        max-rows="100"
                        no-resize
                        :class="{ 'is-danger': errors.length > 0 }"
                    />
                    <p class="font-size-14 mt-1" :class="{ error: errors.length > 0 }">{{ errors[0] }}</p>
                  </div>
                </ValidationProvider>
              </b-form-group>
            </div>
          </b-form>
        </div>
      </div>
      <template v-slot:modal-footer>
        <div class="w-100 center">
          <base-button  :button="BO_QUA_BUTTON_LABEL" class="btn btn-line" @click="hideModal()">
            {{ BO_QUA_BUTTON_LABEL }}
          </base-button>
          <base-button  button="ĐỒNG Ý" class="btn btn-main ml-2" @click="doiMatKhau()">
            
          </base-button>
        </div>
      </template>
    </b-modal>
  </ValidationObserver>
</template>

<script>
import _cloneDeep from "lodash/cloneDeep";
import {BO_QUA_BUTTON_LABEL} from "../../../constants/constants";
const defaultForm = {
  password: "",
  newPassword: "",
  confirmPassword: "",
};
export default {
  name: "QuanLyMatKhau",
  data() {
    return {
      laTaoMoi: false,
      BO_QUA_BUTTON_LABEL: BO_QUA_BUTTON_LABEL,
      internalForm: _cloneDeep(defaultForm),
    };
  },
  props: {
    danhSachCanBo: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  methods: {
    hideModal() {
      this.$bvModal.hide("thay-doi-mat-khau"),
      this.internalForm = _cloneDeep(defaultForm)
    },
    doiMatKhau() {
      this.$emit("doiMatKhau");
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    getInternalForm() {
      return this.internalForm;
    },
  },
};
</script>
